import React, { useState } from "react";
import * as dateFNS from 'date-fns';
import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button, Checkbox } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, Notes } from "./styles";


const RelatorioPagamentosPeriodo = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [reportLink, setReportLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateReport = async () => {
    if(!dataInicio || !dataFinal) {
      return swal("Período da pesquisa obrigatório", "Atualize o período do relatório e tente novamente", "warning");
    }

    setLoading(true);

    try {
      const response = await producaov2.post('/admin/reports/cobrancas-periodo', {
        startPeriod: dataInicio,
        endPeriod: dataFinal,
      });
  
      setReportLink(response.data.url);
    } catch(error) {
      swal('Houve um erro ao gerar o relatorio', 'Contate TI para verificar o problema', 'error');
    } finally {
      setLoading(false);
    }
  }

  const handleDownloadReport = () => {
    setReportLink(null);
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório de Pagamentos Pagarme</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                  min={dataInicio ? dateFNS.format(dateFNS.addDays(new Date(dataInicio), 2), 'yyyy-MM-dd') : undefined}
                />
              </FormField>
              <div>
                <strong>Busca cobranças:</strong>
                <ul>
                  <li>Pedidos pagos</li>
                  <li>Faturas pagas</li>
                  <li>Faturas pendentes, normalmente boleto</li>
                  <li>Faturas com falha</li>
                </ul>
              </div>
            </FormBlock>
            <FormGroup>
              {reportLink ? (
                <Button
                  as="a"
                  href={reportLink}
                  onClick={handleDownloadReport}
                  style={{ minWidth: "80px" }}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              ) : (
                <Button
                  color="orange"
                  onClick={generateReport}
                  loading={loading}
                >
                  Gerar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioPagamentosPeriodo;
